export { handleConfiguratorActions } from "./handle-configurator-actions";
